import { createDomain, sample } from 'effector'
import { Car, OsgopImageImportResult } from '~/shared/api'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const POLL_INTERVAL_MS = 3000
const POLL_TIMEOUT_MS = 3600_000

const domain = createDomain('pages.cars.list.importOsgopImageTemplate')

export type ImportStatus =
  | 'idle'
  | 'uploading'
  | 'pending'
  | 'processing'
  | 'done'
  | 'failed'

const pollStatusUpdated = domain.createEvent<'pending' | 'processing'>()

export const $importStatus = domain.createStore<ImportStatus>('idle')

async function pollStatus(jobId: string): Promise<OsgopImageImportResult> {
  const deadline = Date.now() + POLL_TIMEOUT_MS

  while (Date.now() < deadline) {
    await new Promise((resolve) => setTimeout(resolve, POLL_INTERVAL_MS))

    const status = await Car.osgopImageMassImportStatus(jobId)

    if (status.status === 'done') {
      return {
        processed: status.processed,
        skipped: status.skipped,
        errors: status.errors,
      }
    }

    if (status.status === 'failed') {
      throw new Error(status.message)
    }

    pollStatusUpdated(status.status)
  }

  throw new Error('Превышено время ожидания импорта')
}

export const osgopImageMassImportFx = domain.createEffect<
  File,
  OsgopImageImportResult,
  Error
>({
  async handler(file) {
    const { jobId } = await Car.osgopImageMassImport(file)
    return await pollStatus(jobId)
  },
})

$importStatus
  .on(osgopImageMassImportFx, () => 'uploading')
  .on(pollStatusUpdated, (_, status) => status)
  .on(osgopImageMassImportFx.done, () => 'done')
  .on(osgopImageMassImportFx.fail, () => 'failed')

sample({
  clock: osgopImageMassImportFx.failData,
  fn(e) {
    return {
      message: e.message,
      variant: 'error' as const,
    }
  },
  target: [snackbarEnqueued],
})
